import XLSX from "xlsx";

function createWs(data: any, fields: Array<any>, titles: any) {
  const ws: any = XLSX.utils.json_to_sheet(data, {
    header: fields,
  });
  const range = XLSX!.utils!.decode_range(ws["!ref"]);
  for (let c = range.s.c; c <= range.e.c; c++) {
    const header = XLSX.utils.encode_col(c) + "1";
    ws[header].v = titles[ws[header].v];
  }
  return ws;
}

export { createWs };
